/**
 * hardcoding the subnav items for now because of issue querying this data
 * https://everlywell.atlassian.net/browse/EWD-14167
 */
export const subCategories = [
  {
    node: {
      id: 'virtual-care-subnav',
      slug: 'virtual-care',
      title: 'Virtual Care',
    },
  },
  {
    node: {
      id: 'sti-testing-sub-nav',
      slug: 'sti-testing',
      title: 'STI Testing',
    },
  },
  {
    node: {
      id: 'food-sensitivity-sub-nav',
      slug: 'food-sensitivity',
      title: 'Food Sensitivity',
    },
  },
  {
    node: {
      id: 'weight-management-sub-nav',
      slug: 'weight-management',
      title: 'Weight Management',
    },
  },
  {
    node: {
      id: 'colon-cancer-sub-nav',
      slug: 'colon-cancer',
      title: 'Colon Cancer',
    },
  },
];
